export const writingData = [
  {
    id: "at-last-rest",
    title: "At Last, Rest",
    category: "Poem",
    date: "2026",
    excerpt: "Instead, let it be a daughter's heavy head on a gentle shoulder, carried from the backseat into a home...",
    content: [
      {
        type: "verse",
        stanzas: [
          [
            "Instead, let it be a daughter's heavy head",
            "on a gentle shoulder, carried from the backseat",
          ],
          [
            "into a home that has long forgotten how to shut",
            "its doors and the ghosts that pass through them,",
          ],
          [
            "where between half-lidded eyes, a glow of light from",
            "the lamp pouring blurry-yellow on the carpet, let it be",
          ],
          [
            "the soft body of a mother with the space to fit",
            "her daughter nestled fast, where in her arms she finds",
          ],
          [
            "a cradle like that she slept in before her body",
            "remembered falling onto knees kissing pavement,",
          ],
          [
            "to later wrap in tenderness of a palm pressing",
            "pulse back under her skin, let it be coming home",
          ],
          [
            "to a puzzle on the coffee table with two pieces",
            "set aside like a promise: I will wait for you."
          ]
        ]
      }
    ]
  },
  {
    id: "backfloat",
    title: "Backfloat",
    category: "Poem",
    date: "2026",
    excerpt: "In the lake of silver where I learned how to be held by nothing more than gentle water...",
    content: [
      {
        type: "verse",
        stanzas: [
          [
            "In the lake of silver",
            "where I learned",
            "how to be held by nothing",
            "more than gentle water",
            "and the air in my lungs,",
            "where I learned",
            "a way to survive, I",
            "may be",
            "pale and belly-up like",
            "a dead fish, but",
            "breathing, I",
            "may be",
            "dissolving",
            "but the remnants are so",
            "pretty",
            "& I do not know",
            "very much,",
            "but I imagine",
            "that as the tide",
            "brings the rocks closer",
            "to roundness, so too",
            "it brings me closer",
            "to flight,",
            "& a dead fish",
            "still has something",
            "to give",
            "& the pine trees",
            "gesture at the sky,",
            "pointing me to heaven,",
            "another place for me",
            "to swim."
          ]
        ]
      }
    ]
  },
  {
    id: "burial",
    title: "Burial",
    category: "Poem",
    date: "2026",
    excerpt: "He brings me beachside under a drooping sky & armed with two round-point shovels...",
    content: [
      {
        type: "verse",
        stanzas: [
          [
            "He brings me beachside",
            "under a drooping sky",
            "& armed with two round-point",
            "shovels with carbon-steel heads,",
            "he tells me,",
            { text: "I keep dreaming about this,", italic: true },
            "and shoves the tip into the sand",
            "& when I follow his motion,",
            "it cuts through swift and smooth,",
            "and I tell him,",
            { text: "Maybe I have had the same dream,", italic: true },
            "& when the rain starts to fall,",
            "it is so light that I cannot tell",
            "it from the spray against the rocks,",
            "& I am having trouble pretending",
            "that I cannot feel the sediment",
            "shifting beneath our feet,",
            "the edges of it caving in",
            "& when he pours the sand out",
            "he does it so gently, so I tell him",
            "what I will miss most:",
            "the sea spray, the ache",
            "in my shoulders, the roundness of the",
            "sand dollar I slipped in my pocket",
            "& he tells me",
            { text: "When I'm tired enough, I stop dreaming", italic: true },
            { text: "at all", italic: true },
            "& we keep digging until",
            "we stand on the edge",
            "of our resting place, gritty",
            "with effort and almost somber",
            "& we have nothing to put in our grave."
          ]
        ]
      }
    ]
  },
    {
    id: "capture",
    title: "Capture",
    category: "Essay",
    date: "2022",
    excerpt: "It's teenage rebellion wrought in outlines, late-night laughter and scenes bleached by fluorescent street lamps...",
    content: [
      {
        type: "paragraph",
        text: "It's teenage rebellion wrought in outlines, late-night laughter and scenes bleached by fluorescent street lamps. Our bare feet slip on the pebble-and-dirt shore that we wish was sand, and we laugh even as we feel the familiar quirks of our hometown becoming something closer to shortcomings. I am not intoxicated (I didn't drink last summer) but decidedly drunk, on nothing but sleeplessness and adrenaline. There is no climactic sprint to the water. Self-consciousness keeps our eyes closed, even as we turn our backs, fumbling in darkness. Clothes pile on rocks, propped carefully above the dust and dirt that makes up our shore. I am the last, and I shiver as I wait, listening to the rustle of fabric and the slow, deliberate ripples in the water. Every sound is deafening. I shed my clothes-leaving them carefully folded-and wade into the lake."
      },
      {
        type: "paragraph",
        text: "Ankles. Knees. Hips. Chest. Shoulders. Chin. My head goes under. The water is warm. I slide over water-worn pebbles, find no purchase on the lakebed, find the smoothness freeing."
      },
      {
        type: "paragraph",
        text: "We have nothing to say, but there is something in the silence that feels like trust. The warmth of the water is nothing against the heat of my skin, the peace precarious and gentle. When I tilt my head back to the sky, I can imagine I am immersed in space. My body is floating, and I am floating out of my body."
      },
      {
        type: "paragraph",
        segments: [
          { text: "I will write this feeling later, shitty teenage poetry that cannot capture the moment. It is the closest I will come to capturing the moment. " },
          { text: "(I am looking down into the sky, as the world runs out of breath to hold. / Is this what it takes to freeze a moment? / To swim forever in the stars?) ", italic: true },
          { text: "I will think about the word capture. I capture a moment I record it. I alter it, claim it, constrain it. The impulse is seductive and perverse." }
        ]
      },
      {
        type: "paragraph",
        text: "Unfamiliar voices drift across the water, and even in their softness, they pull me in. I am no longer submerged in space. I remember how I am supposed to feel: euphoric and dangerous, youthful and infallible. Unease coils in my stomach instead, anchoring me to shore."
      },
      {
        type: "paragraph",
        text: "\"I'm getting out.\" I skim the surface of the water with my hand, and the cascading sound smooths the edges of anxiety from my voice."
      },
      {
        type: "paragraph",
        text: "\"Why? Just stay a little longer.\" We lapse back into silence, and I settle back into my body. I hold myself still as headlights blink through the treeline, as I see (imagine) cop cars circling round and round the lake."
      },
      {
        type: "paragraph",
        text: "\"I'm getting out.\" Nobody stops me this time, and I feel the warmth of the water dissipate into the sudden cold of open air. I remember now that I made no ripples, no sound, in fact, made no effect at all. In memory, the water is like glass-smooth, clear, unblemished even though this is an impossibility."
      },
      {
        type: "paragraph",
        text: "The sodden soles of my feet are accumulating dirt, lake water mixing into mud. I wonder, briefly, if there might be broken glass on the shore. I am scared of tetanus. \"You can't get tetanus from glass,\" my friends will tell me later. I don't know this when I pull on my socks, gingerly, as if gentleness might keep the gray-brown of the mud from bleeding into the white of the fabric. I sit, huddled and small in my borrowed towel, and I watch the silhouettes of my friends in the still-calm water."
      },
      {
        type: "paragraph",
        text: "My feet feel gritty in my socks. I pull out my journal."
      },
      {
        type: "heading",
        isItalic: true,
        text: "August 3rd, 2022: 2:06 a.m."
      },
      {
        type: "paragraph",
        isItalic: true,
        text: "I am in love with empty streets and flickering lights of not-quite-closed-down corner stores. The peace and freedom of summer, and the trust that the murmuring voices on the docks 100 (200?) feet counter-clockwise around the lake are just people-people who also want to be let alone-and not the cop from the parking lot who vanished in the time it took for us to find towels."
      },
      {
        type: "paragraph",
        isItalic: true,
        text: "Five minutes ago, I lost my skinny-dipping virginity."
      },
      {
        type: "paragraph",
        isItalic: true,
        text: "I can feel the bugs on my left ankle and my right arm or maybe it's just the crawling, itching feeling of being exposed in a residential neighborhood with incessant street lighting. Tom and Lily are still in the water, and maybe I'm jealous that they're still wrapped in cool calmness, not only of the water but of their brazen invincibility."
      },
      {
        type: "paragraph",
        isItalic: true,
        text: "I can't tell if they're approaching me, or if it's simply the illusion of the ripples hitting the shoreline."
      },
      {
        type: "paragraph",
        text: "This is not how I would have written the experience now, or a week after, or even the next morning. (Why did I say \"skinny-dipping virginity\"? Too vulgar. Did I mean \"let alone\" or \"left alone\" or something else entirely?) I badly want to rewrite, revise, replace my own recordings."
      },
      {
        type: "paragraph",
        text: "This is not even how I remember that night. I am profoundly and irreparably frightened by this fact, that my memory is fallible. Who might be approaching me? Was I imagining the sloshing of my friends stumbling out of the water, or perhaps the footsteps of the people who were sitting at the docks? This is not how I want to remember that night. Perhaps a few years will push these stories across the threshold from memory to fiction. How will my past change then? Perhaps my summer-self will become brave."
      },
      {
        type: "paragraph",
        text: "My entry ends, even as the night drags on. We watch Friday the 13th, not because we want to but because we cannot resist the inertia of our own experience. We pretend to be scared of blood and gore and death, but I am dwelling on living. We step out of Tom's house, drowsy and delirious, and drunk on both. The sun is coming up."
      },
      {
        type: "paragraph",
        text: "I cannot name the phenomenon by which this happens, cannot defend my memory, but I swear the sky is green."
      }
    ]
  },
];